module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkAQAAAABYmaj5AAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QAAd2KE6QAAAAHdElNRQfdCggPCBrTl6FQAAAAS0lEQVQ4y2P4jwQ+MAww7wADDNgPCh7QUcz/BwOPHxxCfxgGAw/ksgMooTRwPH5o2hkUPGAAMfDDw2ygecipZ0B5A56LEbzBU9YBAIqm7lvH51FOAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDE4LTA4LTEzVDE1OjI2OjQzKzA5OjAweQ3b9QAAACV0RVh0ZGF0ZTptb2RpZnkAMjAxMy0xMC0wOFQwNjowODoyNiswOTowMMvnDN4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/tag/36h11/tag36_11_00360_100x100.png
// module id = f5Ar
// module chunks = 0